document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.sticky-ctas-wrapper')) {
    function adjustStickyCtas(evt) {
      const footer = document.querySelector('footer.main');
      if ((document.scrollingElement.scrollTop + document.scrollingElement.clientHeight) > (footer.offsetTop)) {
        document.querySelector('.sticky-ctas-wrapper').classList.add('attached')
        document.querySelector('.sticky-ctas-wrapper').classList.remove('sticky');
      } else {
        document.querySelector('.sticky-ctas-wrapper').classList.remove('attached')
        document.querySelector('.sticky-ctas-wrapper').classList.add('sticky');
      }
    }

    window.addEventListener('scroll', adjustStickyCtas);
    window.addEventListener('resize', adjustStickyCtas);
  }
});